import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import BasicDetails from "./BasicDetails";
import PurchaseDetails from "./PurchaseDetails";
import AssignmentDetails from "./AssignmentDetails";
import MaintenanceWarranty from "./MaintenanceWarranty";
import SupportingDocument from "./SupportingDocument";


const BaseForm = ({ setIsAddDuesModal, addAssetFunctionMutate, isaddAssetLoading, setFormData, formData }) => {

    const [selectedForm, setSelectedForm] = useState(null);

    const onClose = () => {
        setIsAddDuesModal(false);
    }

    const renderContent = () => {
        switch (selectedForm) {
            case "2":
                return <PurchaseDetails setIsAddDuesModal={setIsAddDuesModal} setSelectedForm={setSelectedForm} setFormData={setFormData} formData={formData} />;
            case "3":
                return <AssignmentDetails setIsAddDuesModal={setIsAddDuesModal} setSelectedForm={setSelectedForm} setFormData={setFormData} />;
            case "4":
                return <MaintenanceWarranty setIsAddDuesModal={setIsAddDuesModal} setSelectedForm={setSelectedForm} setFormData={setFormData} formData={formData} addAssetFunctionMutate={addAssetFunctionMutate}/>;
            case "5":
                return <SupportingDocument setIsAddDuesModal={setIsAddDuesModal} setSelectedForm={setSelectedForm} setFormData={setFormData}/>;
            default:
                return (
                    <BasicDetails setIsAddDuesModal={setIsAddDuesModal} setSelectedForm={setSelectedForm} onClose={onClose} addAssetFunctionMutate={addAssetFunctionMutate} isaddAssetLoading={isaddAssetLoading} setFormData={setFormData}/>
                );
        }
    };



    return (
        <Container>
            <Header>
                <Title>{"Add Assets"}</Title>
                <CloseButton onClick={onClose}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>
                {renderContent()}
            </Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;

export default BaseForm;